module.exports = __webpack_public_path__ + "static/media/phone_transparrent.ebe8576b.png";